export default __webpack_public_path__ + "static/media/submit-table-row.92047fc2.svg";